import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  constructor() {}

  emailOrMobileValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value?.trim();

    if (!value) return { required: true };

    const isNumeric = /^[0-9]+$/.test(value);
    const isEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
    const isMobile = /^[0-9]{10}$/.test(value);

    if (isNumeric && !isMobile) {
      return { invalidMobile: true };
    } else if (!isNumeric && !isEmail) {
      return { invalidEmail: true };
    }

    return null;
  }
}
